import { Tag } from 'antd';
import styled from 'styled-components';

export const BoldNameSpan = styled.span<{ fontWeight?: number | string }>`
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: ${(props) => props.fontWeight ?? 600};
  line-height: 20px;
  color: var(--color-text-base, #2e2e2e);
`;

export const ColoredTag = styled(Tag)<{
  bgcolor?: string;
  bordercolor?: string;
  $smaller?: boolean;
}>`
  font-family: Inter, sans-serif;
  font-size: ${(props) => (props.$smaller ? '10px' : '12px')};
  font-weight: 600;
  line-height: 20px;
  border-radius: 4px;
  color: ${(props) =>
    props.color
      ? props.color
      : 'var(--color-text-base, var(--color-text-dark, #042a2a))'} !important;
  background-color: ${(props) =>
    props.bgcolor
      ? props.bgcolor
      : 'var(--color-surface, #ffffff)'} !important;
  border-color: ${(props) =>
    props.bordercolor
      ? props.bordercolor
      : 'var(--color-border, transparent)'} !important;

  .anticon {
    color: inherit !important;
  }
`;
